import React from 'react';
import PropTypes from 'prop-types';

const BreadcrumbsList = ({ data }) => {
  const renderList = (data || []).map(({ id, name, url }) => (
    <li key={id || name}>
      <a href={url}> { name } </a>
    </li>
  ));
  return (
    <ul className="list">{ renderList }</ul>
  );
};

BreadcrumbsList.propTypes = {
  data: PropTypes.array.isRequired,
};

export default BreadcrumbsList;
